// useTenantSignalR.js
// Custom hooks for consuming the TenantSignalRContext.

import { useContext, useEffect, useRef } from "react";
import { TenantSignalRContext } from "../Context/TenantSignalRContext";

export const useTenantSignalR = () => {
  const context = useContext(TenantSignalRContext);
  if (!context) {
    throw new Error(
      "useTenantSignalR must be used within a TenantSignalRProvider",
    );
  }
  return context;
};

export const useTenantSignalREvent = (
  eventName,
  handler,
  hubName = "notification",
) => {
  const { connections } = useTenantSignalR();
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const connection = connections[hubName];
    if (!connection) return;

    const wrappedHandler = (...args) => {
      handlerRef.current(...args);
    };

    connection.on(eventName, wrappedHandler);

    return () => {
      connection.off(eventName, wrappedHandler);
    };
  }, [connections, eventName, hubName]);
};
